<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class=" col-sm-5">
            <div class="mb-3">
                <h6 class="f-w-700 pb-1">{{ t('DepartmentNumber') }} : {{compState.no}}</h6>
            </div>
        </div>
        <div class=" col-sm-7">
            <div class="row h-100">
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="show-on-menu" type="checkbox" value=""
                                v-model="compState.showOnMenu">
                            <label class="form-check-label" for="show-on-menu">{{ t('ShowOnMenu') }}</label>
                        </div>
                    </div>
                </div>
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="sele-department" type="checkbox" value=""
                                v-model="compState.saleDepartment">
                            <label class="form-check-label" for="sele-department">{{ t('SaleDepartment') }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-5">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('DepartmentName') }}</h6>
                </label>
                <input v-model="compState.name" class="form-control" type="text" :placeholder="t('DepartmentName')" maxlength="32">
            </div>
        </div>
        <div class="col-sm-7">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('AlternativeDisplayLanguage') }}</h6>
                </label>
                <input class="form-control" type="text" :placeholder="t('AlternativeDisplayLanguage')"
                    v-model="compState.altLangText" maxlength="32" readonly data-bs-toggle="modal"
                    data-original-title="test" data-bs-target="#alt-lang-modal">
            </div>
        </div>
    </div>
    <div class="row ">
        <div class="col-sm-5">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Rate') }}</h6>
                </label>
                <div class="input-group">
                    <select v-model="compState.taxRate" class="form-select" aria-label="Tax Rate">
                        <option value="" disabled>{{ t('TaxRate') }}</option>
                        <option v-for="tax in taxList" :key="String(tax.id)" :value="tax.name">
                            {{ tax.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class=" row mb-3">
        <div class=" col-5">
            <label>
                <h6 class="f-w-700">{{ t('DisplayOrder') }}</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" :placeholder="t('Threshold')" v-model="compState.displayOrder">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="displayOrderDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="displayOrderIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-7" style="margin-top: 30px;">
            <div class="row h-100">
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="service-check" type="checkbox" value=""
                                v-model="compState.nonDiscountable">
                            <label class="form-check-label" for="service-check">{{ t('NonDiscountable') }}</label>
                        </div>
                    </div>
                </div>
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="surchargeable-check" type="checkbox" value=""
                                v-model="compState.nonSurchargeable">
                            <label class="form-check-label" for="surchargeable-check">{{ t('NonSurchargeable') }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-5 ">
            <div class=" checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="scale-check" type="checkbox" value=""
                        v-model="compState.scaleDepartment">
                    <label class="form-check-label" for="scale-check">{{ t('ScaleDepartment') }}</label>
                </div>
            </div>
        </div>
        <div class="col-sm-7">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('UnitOfSale') }}</h6>
                </label>
                <div class="input-group">
                    <select class="form-select" aria-label="Tax Rate" v-model="compState.unitOfSale">
                        <option value="">{{ t('UnitOfSale') }}</option>
                        <option value="Individually">{{ t('Individually') }}</option>
                        <option value="Gram">{{ t('Gram') }}</option>
                        <option value="Kilogram">{{ t('Kilogram') }}</option>
                        <option value="Ounce">{{ t('Ounce') }}</option>
                        <option value="Pound">{{ t('Pound') }}</option>
                        <option value="Milliliter">{{ t('Milliliter') }}</option>
                        <option value="Liter">{{ t('Liter') }}</option>
                        <option value="Pint">{{ t('Pint') }}</option>
                        <option value="Quart">{{ t('Quart') }}</option>
                        <option value="Gallon">{{ t('Gallon') }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <departmentsAltLangModal @on-save="onEditAltLang" />
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useDepartmentsStore } from '@/store/management/departmentsStore';
import { useTaxesStore } from '@/store/management/taxesStore';
import type { Department } from '@/store/management/departmentsStore';

import { useI18n } from 'vue-i18n'
import { departmentsBasicLanguage } from '@/core/locales/departments-language';

const { t } = useI18n({
  messages: departmentsBasicLanguage
})

const departmentsAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/dapartmentsPage/departmentsAltLangModal.vue'))

const departmentsStore = useDepartmentsStore()
const taxesStore = useTaxesStore();

onMounted(() => {
    taxesStore.initializeTaxes();
});

const taxList = computed(() => taxesStore.getTaxesList);

onMounted(() => {
    taxesStore.initializeTaxes();
    if (tempActiveDepartment.value?.id) {
        compState.id = tempActiveDepartment.value.id
        compState.no = tempActiveDepartment.value.no
        compState.name = tempActiveDepartment.value.name
        compState.showOnMenu = tempActiveDepartment.value.showOnMenu
        compState.saleDepartment = tempActiveDepartment.value.saleDepartment
        compState.taxRate = tempActiveDepartment.value.taxRate
        compState.displayOrder = tempActiveDepartment.value.displayOrder
        compState.nonDiscountable = tempActiveDepartment.value.nonDiscountable
        compState.nonSurchargeable = tempActiveDepartment.value.nonSurchargeable
        compState.scaleDepartment = tempActiveDepartment.value.scaleDepartment
        compState.unitOfSale = tempActiveDepartment.value.unitOfSale
        compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
    }
    console.log('tempActiveDepartment', tempActiveDepartment.value);

})

const compState = reactive({
    id: '',
    no: '',
    name: '',
    showOnMenu: false,
    saleDepartment: false,
    taxRate: '',
    displayOrder: 0,
    nonDiscountable: false,
    nonSurchargeable: false,
    scaleDepartment: false,
    unitOfSale: '',
    altLangText: ''
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}

const activeDepartment = computed(() => {
    return departmentsStore.getActiveDepartment
})

const tempActiveDepartment = computed(() => {
    return departmentsStore.getTempActiveDepartment
})

const activeDepartmentId = computed(() => {
    return departmentsStore.getActiveDepartmentId
})

watch(activeDepartmentId, (newVal) => {
    if (newVal) {
        const department = activeDepartment.value
        compState.id = department.id
        compState.no = department.no
        compState.name = department.name
        compState.showOnMenu = department.showOnMenu
        compState.saleDepartment = department.saleDepartment
        compState.taxRate = department.taxRate
        compState.displayOrder = department.displayOrder
        compState.nonDiscountable = department.nonDiscountable
        compState.nonSurchargeable = department.nonSurchargeable
        compState.scaleDepartment = department.scaleDepartment
        compState.unitOfSale = department.unitOfSale
        compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    departmentsStore.setTempActiveDepartment({
        ...tempActiveDepartment.value,
        id: newVal.id,
        name: newVal.name,
        showOnMenu: newVal.showOnMenu,
        saleDepartment: newVal.saleDepartment,
        taxRate: newVal.taxRate,
        displayOrder: newVal.displayOrder,
        nonDiscountable: newVal.nonDiscountable,
        nonSurchargeable: newVal.nonSurchargeable,
        scaleDepartment: newVal.scaleDepartment,
        unitOfSale: newVal.unitOfSale,
    } as Department)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
}
</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>